import React, { ReactNode } from "react";
import { Calendar } from "primereact/calendar";

interface TimeInputProps {
  label: string;
  icon: ReactNode;
  placeholder?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
}

interface TimeInputProps {
  label: string;
  icon: ReactNode;
  placeholder?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
}

const TimeInput: React.FC<TimeInputProps> = ({ label, icon, placeholder, value, onChange }) => {
  const roundToStep = (date: Date, step: number) => {
    const minutes = date.getMinutes();
    const rounded = Math.round(minutes / step) * step;
    date.setMinutes(rounded);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  };
  return (
      <div className="relative">
          <div className={`absolute z-10 -top-2 left-[14px] text-[12px] uppercase bg-white px-[4px] py-[2px] transition-all ${
              value ? "text-[#3b49c0]" : "text-violet-300"
          }`}>
              {label}
          </div>
          <div className="relative">
              <span className="absolute z-10 left-[14px] top-1/2 -translate-y-1/2">{icon}</span>
              <Calendar 
                  value={value} 
                  onChange={(e) => {
                    const selected = e.value ? roundToStep(new Date(e.value), 30) : null;
                    onChange(selected);
                  }}
                  timeOnly 
                  placeholder={placeholder} 
                  stepMinute={30}
              />
          </div>
      </div>
  );
};


export default TimeInput;
